import { createContext, useContext, useState } from "react";

const PRCustomBottlerSelectionContext = createContext();

// Context Provider Component
export const PRCustomBottlerSelectionProvider = ({ children }) => {
  const [customSelectedData, setCustomSelectedData] = useState([]);

  return (
    <PRCustomBottlerSelectionContext.Provider
      value={{ customSelectedData, setCustomSelectedData }}
    >
      {children}
    </PRCustomBottlerSelectionContext.Provider>
  );
};

// Custom Hook for easy access
export const usePRCustomBottlerSelection = () =>
  useContext(PRCustomBottlerSelectionContext);
